export default __webpack_public_path__ + "static/media/instreamads.350d9b13.svg";